import { exposeIfDev } from '../utils/general-utils';
import { configureStore } from '@reduxjs/toolkit'

import { allReducers, allConfigurators } from '../Components/reducers';

const store = configureStore({
  reducer: allReducers,
})

Object.keys(allConfigurators).forEach(configuratorName => {
  const configurator = allConfigurators[configuratorName];
  configurator(store);
})

exposeIfDev({
  allReducers,
  store,
});

export default store;